export var THREE_LETTER_PRIMARY_COUNTRY_CODES = {
    USA: "USA",
    CAN: "CAN",
    GBR: "GBR",
    FRA: "FRA",
    DEU: "DEU",
    NLD: "NLD",
    ITA: "ITA",
    ESP: "ESP",
    // T2
    BEL: "BEL",
    AUT: "AUT",
    LUX: "LUX",
    IRL: "IRL",
    // T3
    NOR: "NOR",
    CHE: "CHE",
    FIN: "FIN",
    SWE: "SWE",
    DNK: "DNK",
    // Portugal
    PRT: "PRT",
    // Australia
    AUS: "AUS"
};
